<!--  -->
<template>
    <div class="box">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item v-if="isMain" :to="{ path: '/', query: {tab: 0} }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item :to="{ path: '/kitchenwareMain', query: {tab: 9} }">厨具首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/chujuSub', query: {typename: $route.query.typename,showName:$route.query.showName} }">{{ titleName }}</el-breadcrumb-item>
        <!-- <el-breadcrumb-item v-if="isShow && !isMain"><span @click="backFun" style="color: #303133;font-weight: 600;">{{ titleName }}</span></el-breadcrumb-item> -->
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
  
      <div class="content">
          <div class="title">{{ info.title }}</div>
          <div class="label">发布时间：{{ info.createTime }}</div>

          
  
          <!-- <img :src="downloadUrl + info.photo" alt="" class="img"> -->
  
          <div class="duration" style="margin-top: 20px;overflow-y: auto;word-wrap: break-word;" v-html="info.content"></div>

          <div style="display: flex;width: 100%; margin-top: 20px;" v-if="files.length > 0">
            <span>附件:</span>
            <div style="display: flex;flex-direction: column;">
                <span style="color: blue;text-decoration: underline;cursor: pointer;margin-bottom: 10px;margin-left: 10px;" v-for="item in files" @click="downloadExcel(item)">{{ fixImage(item).split("_")[0] }}</span>
            </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Server,httpurl } from "@/server";
  export default {
    data () {
      return {
          id: '', // 文章id
          info: {},
          downloadUrl: '',
          files:[],

          isMain:false,
          isShow:false,
      }
    },
    created() {
      this.downloadUrl = this.$downloadUrl
      console.log(this.$route.query.id);
      this.id = this.$route.query.id
      
      this.isShow = (this.$route.query.isMain=='true')?false:true
      this.isMain = (this.$route.query.isShow=='true')?true:false
      
      this.titleName = this.$route.query.showName?this.$route.query.showName : this.$route.query.typename
      this.getData()
    },
    methods: {
        backFun () {
          if (this.isShow && this.isMain) {
            this.$router.push({
                path: '/chujuSub',
                query:{
                  typename:title
                }
            })
          } else {
            history.go(-1);
          }
        },
        getData() {
            Server.getlzcjfwContentInfo({id: this.id}).then(res => {
                console.log(res);
                if(res.success) {
                    this.info = res.result
                    // if(!this.titleName) {
                    //     this.titleName = this.info.typename
                    // }
                    if (this.info.files) {
                      this.files = this.info.files.split(',')
                    }
                }
            })
        },
        
      getUrl() {
        return httpurl + '/sys/common/static/';
      },
      fixImage (file) {
        var arr = file.split("/"); // 使用逗号分割字符串
        var lastElement = arr.slice(-1)[0]; // 取得最后一个元素
        return lastElement
      },
  
      async downloadExcel (fileName) {
          var fileUrl = this.getUrl()
        var fileLastName = this.fixImage(fileName).split("_")[0] + this.fixImage(fileName).slice(this.fixImage(fileName).lastIndexOf('.'))
        const x = new window.XMLHttpRequest();
        x.open('GET', this.getUrl() + fileName, true);
        x.responseType = 'blob';
        x.onload = () => {
            const url = window.URL.createObjectURL(x.response);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileLastName;
            a.click();
        };
        x.send();
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
      .content {
          margin: 20px 0 50px;
          background-color: #fff;
          padding: 50px ;
          box-sizing: border-box;
  
          display: flex;
          flex-direction: column;
          align-items: center;
          .title {
              font-size: 30px;
              font-weight: bold;
              margin-bottom: 45px;
              
          }
            .label {
                font-size: 16px;
                margin-top: 20px;
                color: #898989;
            }
          .img {
              margin: 50px 0;
              max-width: 100%;
          }
          .duration {
              line-height: 35px;
              //text-indent: 0.5em;
          }
      }
  </style>
  